import { render, staticRenderFns } from "./ArticleCard.vue?vue&type=template&id=d55d36d6&"
import script from "./ArticleCard.vue?vue&type=script&lang=js&"
export * from "./ArticleCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports